// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": false,
    "raw": "v3.01.140-10077-g819545007",
    "hash": "g819545007",
    "distance": 10077,
    "tag": "v3.01.140",
    "semver": null,
    "suffix": "10077-g819545007",
    "semverString": "",
    "version": "0.0.0"
};
/* tslint:enable */
